var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grow flex-wrap",attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":"polarArea","height":_vm.height,"width":_vm.width,"options":_vm.basic.chartOptions,"series":_vm.basic.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }